import { Link } from 'react-router-dom';

const footerLinks = {
  services: [
    { label: 'Security Camera Installation', href: '/services/cybersecurity' },
    { label: 'Surveillance Systems (CCTV)', href: '/services/cybersecurity' },
    { label: 'Alarm Systems', href: '/services/cybersecurity' },
    { label: 'Access Control Systems', href: '/services/cybersecurity' },
    { label: 'Smart Home Automation', href: '/services/cybersecurity' },
    { label: 'Business Security Systems', href: '/services/cybersecurity' },
  ],
  company: [
    { label: 'About Us', href: '/about' },
    { label: 'Our Technicians', href: '/about' },
    { label: 'Project Gallery', href: '/about' },
    { label: 'Careers', href: '/about' },
  ],
  locations: [
    { label: 'New York, NY', href: '/locations/new-york' },
    { label: 'Los Angeles, CA', href: '/locations/new-york' },
    { label: 'Chicago, IL', href: '/locations/new-york' },
    { label: 'Houston, TX', href: '/locations/new-york' },
    { label: 'All Locations', href: '/locations/new-york' },
  ],
};

const trustPills = [
  { label: 'Licensed & Insured', icon: 'ri-shield-check-fill' },
  { label: '10-Yr Warranty', icon: 'ri-tools-fill' },
  { label: 'Residential & Commercial', icon: 'ri-home-fill' },
  { label: 'Same-Day Service', icon: 'ri-timer-flash-fill' },
];

export default function Footer() {
  return (
    <footer className="bg-slate-50 border-t border-slate-200">
      {/* Top CTA strip */}
      <div className="border-b border-slate-200 bg-white">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-orange-100 border border-orange-200 flex-shrink-0">
              <i className="ri-camera-fill text-orange-600 text-xl" />
            </div>
            <div>
              <p className="text-slate-900 font-bold text-sm">Ready to secure your property?</p>
              <p className="text-slate-500 text-xs">Free quote · Same-day scheduling · No obligation</p>
            </div>
          </div>
          <div className="flex items-center gap-3 flex-shrink-0">
            <a
              href="tel:+18005551234"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl border border-slate-300 text-slate-700 font-bold text-sm hover:border-slate-400 hover:text-slate-900 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill text-orange-500" />
              (800) 555-1234
            </a>
            <Link
              to="#contact"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-slate-900 text-white font-black text-sm hover:bg-slate-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              Free Security Quote
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>

      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 mb-12">
          {/* Brand col */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-flex items-center mb-5">
              <img
                src="https://storage.readdy-site.link/project_files/0da62401-e0be-45f3-bc33-e277c8c6ee07/705574f5-5d9c-49da-a4c3-693d8a7197bc_secure-logo.jpg?v=fddac8ba09e154ac3e000afc7e4c8117"
                alt="Secure2Ware Security Systems"
                className="h-11 w-auto object-contain block"
              />
            </Link>
            <p className="text-slate-600 text-sm leading-relaxed mb-6 max-w-xs">
              Professional security camera installation, surveillance systems, access control,
              and smart automation for homes and businesses across the United States.
            </p>

            {/* Trust pills */}
            <div className="flex flex-wrap gap-2 mb-6">
              {trustPills.map((b) => (
                <div
                  key={b.label}
                  className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-slate-200 bg-white"
                >
                  <i className={`${b.icon} text-orange-500 text-xs`} />
                  <p className="text-slate-700 text-xs font-semibold">{b.label}</p>
                </div>
              ))}
            </div>

            <div className="flex items-center gap-2.5">
              {['ri-twitter-x-fill', 'ri-linkedin-fill', 'ri-facebook-fill', 'ri-youtube-fill'].map((icon) => (
                <a
                  key={icon}
                  href="/"
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-white border border-slate-200 text-slate-500 hover:text-orange-600 hover:border-orange-200 transition-colors cursor-pointer"
                >
                  <i className={icon} />
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-slate-900 font-bold text-sm mb-5 uppercase tracking-wide">
              <a id="services-footer" href="/services/cybersecurity">Services</a>
            </h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-slate-500 text-sm hover:text-orange-600 transition-colors flex items-center gap-1.5"
                  >
                    <i className="ri-arrow-right-s-line text-slate-400 text-xs" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-slate-900 font-bold text-sm mb-5 uppercase tracking-wide">
              <a id="company-footer" href="/about">Company</a>
            </h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-slate-500 text-sm hover:text-orange-600 transition-colors flex items-center gap-1.5"
                  >
                    <i className="ri-arrow-right-s-line text-slate-400 text-xs" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <h4 className="text-slate-900 font-bold text-sm mt-7 mb-4 uppercase tracking-wide">Locations</h4>
            <ul className="space-y-3">
              {footerLinks.locations.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-slate-500 text-sm hover:text-orange-600 transition-colors flex items-center gap-1.5"
                  >
                    <i className="ri-map-pin-line text-slate-400 text-xs" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-slate-900 font-bold text-sm mb-5 uppercase tracking-wide">
              <a id="contact-footer" href="#contact">Contact</a>
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-2.5 text-sm">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-phone-fill text-orange-500" />
                </div>
                <a
                  href="tel:+18005551234"
                  className="text-slate-700 hover:text-orange-600 transition-colors font-semibold"
                >
                  (800) 555-1234
                </a>
              </li>
              <li className="flex items-start gap-2.5 text-sm">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-mail-fill text-orange-500" />
                </div>
                <a
                  href="mailto:info@secure2ware.com"
                  className="text-slate-500 hover:text-orange-600 transition-colors"
                >
                  info@secure2ware.com
                </a>
              </li>
              <li className="flex items-start gap-2.5 text-sm">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-time-fill text-orange-500" />
                </div>
                <div>
                  <p className="text-slate-600">Mon–Sat: 7am–9pm</p>
                  <p className="text-orange-600 font-semibold text-xs mt-0.5">24/7 Emergency Response</p>
                </div>
              </li>
            </ul>
            <div className="mt-5 p-3.5 rounded-xl bg-orange-50 border border-orange-200">
              <div className="flex items-center gap-1.5 mb-1">
                <i className="ri-shield-star-fill text-orange-500 text-sm" />
                <p className="text-orange-700 text-xs font-bold">Licensed · Insured · Warranted</p>
              </div>
              <p className="text-slate-500 text-xs">Professional installation guaranteed</p>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-slate-200 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-400 text-sm">
            &copy; 2026 Secure2Ware. All rights reserved. | Security Camera Installation &amp; Surveillance Systems
          </p>
          <div className="flex items-center gap-6">
            <a href="/" rel="nofollow" className="text-slate-400 text-sm hover:text-slate-600 transition-colors">
              Privacy Policy
            </a>
            <a href="/" rel="nofollow" className="text-slate-400 text-sm hover:text-slate-600 transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
